<template>
  <div class="app">
    <div class="banner-image-container">
      <div v-if="isBackgroundImageLoading" class="d-flex align-items-center flex-column justify-content-center mt-4">
        <div>
          <div class="spinner-border spinner-class"></div>
        </div>
      </div>
      <img class="banner-image" v-else-if="authUser.user.bg_img" :src="authUser.user.bg_img ? authUser.user.bg_img[0].url : ''" alt="" @load="onLoadHandler" />
      <!-- <img class="banner-image" v-show="!isBackgroundImageLoading && authUser.user.bg_img" :src="authUser.user.bg_img ? authUser.user.bg_img[0].url : ''" alt="" @load="onLoadHandler" /> -->
      <img v-else src="https://mycircle-prod.s3.amazonaws.com/default-profile-bg-img1698993539.jpg" alt="background" class="default-profile-bg-img" />
      <!-- <img class="banner-image" v-if="!isBackgroundImageLoading && authUser.user.bg_img" :src="authUser.user.bg_img ? authUser.user.bg_img[0].url : ''" alt @load="onLoadHandler" /> -->
      <div class="bg-change-icon dovemed-wrapper">
        <button
          class="threedot-menu"
          @click="
            () => {
              $refs.drawerRef.isMobile ? $refs.drawerRef.show() : (displayDots = !displayDots)
            }
          "
        >
          <div class="dot-menu-cont1">
            <div class="camera-icon-btn">
              <label class="camera-bttn cp d-flex justify-content-center align-items-center" aria-hidden="true" :style="{ background: getPrimaryColor() }">
                <font-awesome-icon size="2x" :style="{ color: 'white !important', transform: 'scale(0.5)', height: '100%' }" :icon="['fas', 'camera']" />
              </label>
            </div>
          </div>
          <div :class="`${displayDots ? 'menu-content shadow-card active' : 'menu-content shadow-card'}`">
            <p
              class="card-item"
              @click="
                () => {
                  $refs.bgImageGalleryModal.show(backgroundImages)
                }
              "
            >
              <font-awesome-icon size="1x" :icon="['fal', 'images']" class="mr-2" />
              Select image
            </p>
            <p class="card-item position-relative">
              <font-awesome-icon size="1x" :icon="['fal', 'arrow-from-bottom']" class="mr-2" />
              <input
                title=""
                class="camera-icon-inp position-absolute h-100 w-100"
                type="file"
                accept="image/png, image/jpeg, image/gif, image/svg+xml"
                ref="bg"
                @change="handleBackgroundPicUpload()"
                :style="{ left: '0', opacity: '0' }"
              />
              Upload image
            </p>
            <p class="divider"></p>
            <p @click="remove()" :class="`card-item ${authUser.user.bg_img ? '' : 'disabled-remove-bg-btn'}`">
              <font-awesome-icon size="1x" :icon="['fal', 'trash']" class="mr-2" />
              Remove
            </p>
          </div>
        </button>
      </div>
    </div>
    <div class="dovemed-wrapper m-mw-100">
      <div class="profile-card-container">
        <!-- <template v-if="options.length > 0"> -->
        <ProfileCompleteness :circlesOn="circlesOn" :MembersOnCircles="MembersOnCircles" />
        <!-- <ProfileCompleteness :options="options" :circlesOn="circlesOn" :MembersOnCircles="MembersOnCircles" /> -->
        <!-- </template> -->
      </div>
      <div class="profile-tab">
        <div
          :style="this.$route.path === `/${currentCircle.key_name}/profile/${authUser.user.role}/updates` ? { color: getPrimaryColor(), background: getPrimary50Color() } : { color: '#0F1734' }"
          id="updates"
          :class="this.$route.path === `/${currentCircle.key_name}/profile/${authUser.user.role}/updates` ? 'active-tabs' : 'tabs'"
          @click="handletab($event)"
        >
          Updates
        </div>
        <div
          :style="this.$route.path === `/${currentCircle.key_name}/profile/${authUser.user.role}/about` ? { color: getPrimaryColor(), background: getPrimary50Color() } : { color: '#0F1734' }"
          id="story"
          :class="this.$route.path === `/${currentCircle.key_name}/profile/${authUser.user.role}/about` ? 'active-tabs' : 'tabs'"
          @click="handletab($event)"
        >
          Story
        </div>
        <div
          :style="this.$route.path.includes('dovedaily') ? { color: getPrimaryColor(), background: getPrimary50Color() } : { color: '#0F1734' }"
          id="dovedaily"
          :class="this.$route.path.includes('dovedaily') ? 'active-tabs' : 'tabs'"
          @click="handletab($event)"
        >
          DoveDaily
        </div>
        <div
          :style="
            this.$route.path.includes('allCircleMembers') ||
            this.$route.path.includes('self') ||
            this.$route.path.includes('hospitals') ||
            this.$route.path.includes('clinics') ||
            this.$route.path.includes('nfp') ||
            this.$route.path.includes('hcp') ||
            this.$route.path.includes('providers')
              ? { color: getPrimaryColor(), background: getPrimary50Color() }
              : { color: '#0F1734' }
          "
          id="circles"
          :class="
            this.$route.path.includes('allCircleMembers') ||
            this.$route.path.includes('self') ||
            this.$route.path.includes('hospitals') ||
            this.$route.path.includes('clinics') ||
            this.$route.path.includes('nfp') ||
            this.$route.path.includes('hcp') ||
            this.$route.path.includes('providers')
              ? 'active-tabs'
              : 'tabs'
          "
          @click="handletab($event)"
        >
          Circles
        </div>
        <a-dropdown :trigger="['click']" v-model="displayDots2" :getPopupContainer="trigger => trigger.parentNode" :disabled="isMobile">
          <div
            @click="
              () => {
                $refs.drawerMenuRef.isMobile ? $refs.drawerMenuRef.show() : null
              }
            "
            :style="
              this.$route.path.includes('muteduser') ||
              this.$route.path.includes('qa') ||
              this.$route.path.includes('polls') ||
              this.$route.path.includes('saved') ||
              this.$route.path.includes('profilerev') ||
              this.$route.path.includes('medrev') ||
              this.$route.path.includes('profilercmnd') ||
              this.$route.path.includes('treatmentrcmnd')
                ? { color: getPrimaryColor(), background: getPrimary50Color() }
                : { color: '#0F1734' }
            "
            id="reviews"
            :class="
              this.$route.path.includes('muteduser') ||
              this.$route.path.includes('qa') ||
              this.$route.path.includes('polls') ||
              this.$route.path.includes('saved') ||
              this.$route.path.includes('profilerev') ||
              this.$route.path.includes('medrev') ||
              this.$route.path.includes('profilercmnd') ||
              this.$route.path.includes('treatmentrcmnd')
                ? 'active-tabs'
                : 'tabs'
            "
          >
            <div
              :style="
                this.$route.path.includes('muteduser') ||
                this.$route.path.includes('qa') ||
                this.$route.path.includes('polls') ||
                this.$route.path.includes('saved') ||
                this.$route.path.includes('profilerev') ||
                this.$route.path.includes('medrev') ||
                this.$route.path.includes('profilercmnd') ||
                this.$route.path.includes('treatmentrcmnd')
                  ? { color: getPrimaryColor() }
                  : ''
              "
              class="tabe"
            >
              <!-- {{ selectedTab }} -->
              {{ "Reviews & More" }}
              <font-awesome-icon size="1x" :icon="displayDots2 ? ['far', 'angle-up'] : ['far', 'angle-down']" class="mr-2" />
            </div>
          </div>
          <template #overlay>
            <a-menu>
              <a-menu-item
                id="qa"
                @click="
                  () => {
                    selectedTab = 'Q&A'
                    $router.push({ name: 'PatientQA' })
                  }
                "
                class="card-item"
              >
                Q&A
              </a-menu-item>
              <a-menu-item
                id="polls"
                @click="
                  () => {
                    selectedTab = 'Polls'
                    $router.push({ name: 'PatientPolls' })
                  }
                "
                class="card-item"
              >
                Polls
              </a-menu-item>
              <a-menu-item
                id="saved"
                @click="
                  () => {
                    selectedTab = 'Saved'
                    $router.push({ name: 'PatientSaved' })
                  }
                "
                class="card-item"
              >
                Saved
              </a-menu-item>
              <a-menu-item
                id="profilerev"
                @click="
                  () => {
                    selectedTab = 'Profile Reviews'
                    $router.push({ name: 'PatientProfileReview' })
                  }
                "
                class="card-item"
              >
                Profile Reviews
              </a-menu-item>
              <a-menu-item
                id="medrev"
                @click="
                  () => {
                    selectedTab = 'Medication Reviews'
                    $router.push({ name: 'PatientMedReview' })
                  }
                "
                class="card-item"
              >
                Medication Reviews
              </a-menu-item>
              <a-menu-item
                id="profilercmnd"
                @click="
                  () => {
                    selectedTab = 'Profile Recommendations'
                    $router.push({ name: 'PatientProfileRec' })
                  }
                "
                class="card-item"
              >
                Profile Recommendations
              </a-menu-item>
              <a-menu-item
                id="treatmentrcmnd"
                @click="
                  () => {
                    selectedTab = 'Treatment Recommendations'
                    $router.push({ name: 'PatientTreatmentRec' })
                  }
                "
                class="card-item"
              >
                Treatment Recommendations
              </a-menu-item>
              <a-menu-item
                id="profilercmnd"
                @click="
                  () => {
                    selectedTab = 'Muted User'
                    $router.push({ name: 'PatientMutedUser' })
                  }
                "
                class="card-item"
              >
                Muted Users
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
      </div>
      <div class="child-tab-view">
        <router-view></router-view>
      </div>
    </div>
    <BackgroundImageGallery :handleLoader="handleLoader" ref="bgImageGalleryModal" />
    <AvatarModal ref="avatarModal" :handleProfilePic="handleProfilePic" />
    <DrawerModal ref="drawerMenuRef">
      <div @click="() => $refs.drawerMenuRef.close()">
        <a-menu-item
          id="qa"
          @click="
            () => {
              selectedTab = 'Q&A'
              $router.push({ name: 'PatientQA' })
            }
          "
          class="drawer-item"
        >
          Q&A
        </a-menu-item>
        <a-menu-item
          id="polls"
          @click="
            () => {
              selectedTab = 'Polls'
              $router.push({ name: 'PatientPolls' })
            }
          "
          class="drawer-item"
        >
          Polls
        </a-menu-item>
        <a-menu-item
          id="saved"
          @click="
            () => {
              selectedTab = 'Saved'
              $router.push({ name: 'PatientSaved' })
            }
          "
          class="drawer-item"
        >
          Saved
        </a-menu-item>
        <a-menu-item
          id="profilerev"
          @click="
            () => {
              selectedTab = 'Profile Reviews'
              $router.push({ name: 'PatientProfileReview' })
            }
          "
          class="drawer-item"
        >
          Profile Reviews
        </a-menu-item>
        <a-menu-item
          id="medrev"
          @click="
            () => {
              selectedTab = 'Medication Reviews'
              $router.push({ name: 'PatientMedReview' })
            }
          "
          class="drawer-item"
        >
          Medication Reviews
        </a-menu-item>
        <a-menu-item
          id="profilercmnd"
          @click="
            () => {
              selectedTab = 'Profile Recommendations'
              $router.push({ name: 'PatientProfileRec' })
            }
          "
          class="drawer-item"
        >
          Profile Recommendations
        </a-menu-item>
        <a-menu-item
          id="treatmentrcmnd"
          @click="
            () => {
              selectedTab = 'Treatment Recommendations'
              $router.push({ name: 'PatientTreatmentRec' })
            }
          "
          class="drawer-item"
        >
          Treatment Recommendations
        </a-menu-item>
        <a-menu-item
          id="profilercmnd"
          @click="
            () => {
              selectedTab = 'Muted User'
              $router.push({ name: 'PatientMutedUser' })
            }
          "
          class="drawer-item"
        >
          Muted Users
        </a-menu-item>
      </div>
    </DrawerModal>
    <DrawerModal ref="drawerRef">
      <div @click="() => $refs.drawerRef.close()">
        <p
          class="drawer-item"
          @click="
            () => {
              $refs.bgImageGalleryModal.show(backgroundImages)
            }
          "
        >
          <font-awesome-icon size="1x" :icon="['fal', 'images']" class="mr-2" />
          Select image
        </p>
        <p class="drawer-item position-relative">
          <font-awesome-icon size="1x" :icon="['fal', 'arrow-from-bottom']" class="mr-2" />
          <input
            title=""
            class="camera-icon-inp position-absolute h-100 w-100"
            type="file"
            accept="image/png, image/jpeg, image/gif, image/svg+xml"
            ref="bg"
            @change="handleBackgroundPicUpload()"
            :style="{ left: '0', opacity: '0' }"
          />
          Upload image
        </p>
        <p class="divider w-100 m-0"></p>
        <p @click="remove()" :class="`drawer-item ${authUser.user.bg_img ? '' : 'disabled-remove-bg-btn'}`">
          <font-awesome-icon size="1x" :icon="['fal', 'trash']" class="mr-2" />
          Remove
        </p>
      </div>
    </DrawerModal>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import ProfileCompleteness from "../../commons/ProfileCompleteness"
import { RepositoryFactory } from "../../../repositories/RepositoryFactory"
import s3Upload from "../../../utilities/imageUploader"
import BackgroundImageGallery from "../../Modals/BackgroundImageGallery"
import AvatarModal from "../../Modals/UserAvatarCreationModal.vue"
import { faUserNinja, faImages, faArrowFromBottom, faTrash } from "@fortawesome/pro-light-svg-icons"
import { faAngleDown, faAngleUp } from "@fortawesome/pro-regular-svg-icons"
import { library } from "@fortawesome/fontawesome-svg-core"
import DrawerModal from "../../Modals/DrawerModal.vue"

const UserRepository = RepositoryFactory.get("user")
const AppRepository = RepositoryFactory.get("app")
library.add(faUserNinja, faImages, faArrowFromBottom, faTrash, faAngleDown, faAngleUp)

export default {
  name: "PatientProfile",
  components: { ProfileCompleteness, BackgroundImageGallery, AvatarModal, DrawerModal },
  data() {
    return {
      // options: [],
      // percentTotal: 0,
      circlesOn: 0,
      MembersOnCircles: 0,
      profileData: null,
      cardKeys: null,
      toDeleteKeys: ["id", "created_at", "updated_at", "is_deleted", "user", "story", "diagnosis_date", "user_circle", "about"],
      backgroundImages: [],
      isBackgroundImageLoading: false,
      displayDots: false,
      displayDots2: false,
      selectedTab: "Reviews & More",
      isMobile: false,
    }
  },

  watch: {
    selectedTab() {
      this.displayDots = false
      this.displayDots2 = false
    },
  },

  created() {
    console.warn("PatientProfile.vue is created")
    // this.Completeness()
    this.init()
    // this.getBackgroundImages()
    window.addEventListener("mouseup", () => {
      if (this.displayDots) {
        setTimeout(() => {
          this.displayDots = false
        }, 100)
      }
    })
    window.addEventListener("resize", this.handleResize)
    this.handleResize()
  },

  destroyed() {
    window.removeEventListener("resize", this.handleResize)
  },

  computed: {
    ...mapGetters({
      circleMembersCount: "User/cicleMembersCount",
    }),
  },

  methods: {
    handleResize() {
      if (window.innerWidth < 700) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    },

    handleLoader(val = true) {
      this.isBackgroundImageLoading = val
    },

    async remove() {
      if (!this.authUser.user.bg_img) {
        return
      }
      this.isBackgroundImageLoading = true
      const payload = { bg_img: null }
      try {
        const updateData = await UserRepository.updateProfilePic(payload, this.authUser.user, this.currentCircle.id)
        const authUserData = updateData.data.data[0]
        this.$store.commit("User/setAuthUserProfile", authUserData)
        this.isBackgroundImageLoading = false
        this.$notification.success({ message: "Success", description: "Image removed successfully" })
      } catch (err) {
        this.isBackgroundImageLoading = false
        // console.log(err)
      }
    },

    // Completeness() {
    //   const user = this.authUser.user
    //   const headers = { Authorization: `Bearer ${user.token}` }
    //   this.$http
    //     .get(`${process.env.BASE_API_URL}/${user.role === "patient" ? "normaluser" : "caregiver"}profilecompletion/?circle_id=${this.currentCircle.id}`, { headers })
    //     .then(res => {
    //       this.options = res.data.data
    //       this.percentTotal = res.data.message
    //     })
    //     .catch(err => {})
    // },

    handletab(event) {
      // console.log(event.target.id)
      this.displayDots2 = false
      this.displayDots = false
      switch (event.target.id) {
        case "updates":
          this.selectedTab = "Reviews & More"
          this.$router.push({ path: `/${this.currentCircle.key_name}/profile/${this.authUser.user.role}/updates` })
          break
        case "story":
          this.selectedTab = "Reviews & More"
          this.$router.push({ path: `/${this.currentCircle.key_name}/profile/${this.authUser.user.role}/about` })
          break
        case "dovedaily":
          this.selectedTab = "Reviews & More"
          this.$router.push({ name: "PatientDovedaily" })
          break
        case "circles":
          this.selectedTab = "Reviews & More"
          this.$router.push({ name: "allSelfPatientCircleMembers" })
          break
        case "qa":
          this.$router.push({ name: "PatientQA" })
          break
        case "polls":
          this.$router.push({ name: "PatientPolls" })
          break
        case "saved":
          this.$router.push({ name: "PatientSaved" })
          break
        case "reviews":
          this.$router.push({ name: "PPatientReviews" })
          break
        case "profilerev":
          this.$router.push({ name: "PPatientProfileReview" })
          break
        case "medrev":
          this.$router.push({ name: "PPatientMedReview" })
          break
        case "profilercmnd":
          this.$router.push({ name: "PPatientProfileRec" })
          break
        case "treatmentrcmnd":
          this.$router.push({ name: "PPatientTreatmentRec" })
          break
      }
    },

    onLoadHandler() {
      this.isBackgroundImageLoading = false
    },

    init() {
      UserRepository.getSelfProfile(this.authUser.user, this.currentCircle.id)
        .then(res => {
          this.$store.commit("User/setAuthUserProfileLocation", res.data.data.user_info)
          this.$store.commit("User/setAuthUserProfileBgImg", res.data.data.user_info)
          this.$store.commit("User/setCircleMemberCount", { data: res.data.data.no_of_members })
          this.circlesOn = res.data.data.no_of_circle_on
          this.MembersOnCircles = res.data.data.no_of_members
        })
        .catch(res => {})

      // AppRepository.getRelationShipStatusValues()
      //   .then(res => {
      //     this.$store.commit("User/setRelationshipStatusValues", { data: res.data.data })
      //   })
      //   .catch(err => {})

      // AppRepository.getCurrentSituationValues()
      //   .then(res => {
      //     this.$store.commit("User/setCurrentSituationValues", { data: res.data.data })
      //   })
      //   .catch(err => {})

      // this.$store.dispatch("Circle/diseaseTypes", { type: this.currentCircle.id })
    },

    // getBackgroundImages() {
    //   AppRepository.getBackgroundImageGallery().then(res => {
    //     this.backgroundImages = res.data.data
    //   })
    // },

    /**
     * Handle Background image Upload
     */
    async handleBackgroundPicUpload() {
      console.warn("handleBackgroundPicUpload() is called")
      try {
        this.isBackgroundImageLoading = true
        const file = this.$refs.bg.files[0]
        if (!file.type.includes("image")) {
          this.$notification.error({ message: "Error", description: "Please select only image" })
          this.isBackgroundImageLoading = false
          return
        }
        this.$refs.bg.value = ""
        const headers = { Authorization: `Bearer ${this.authUser.user.token}` }
        const urlPayload = { file_name: [file.name] }
        const urlData = await UserRepository.getPresignedUrl(urlPayload)
        const s3 = await s3Upload(urlData.data.data.url[0], file)
        const result = await this.$http.get(`${process.env.BASE_API_URL}/mastertable/?type=image&code=Background&key=User Upload`)
        const bgPayload = { file_name: urlData.data.data.filename[0], image_type_id: result.data.data[0].id }
        const res = await this.$http.post(`${process.env.BASE_API_URL}/backgroundimage/`, bgPayload, { headers })
        const payload = { bg_img: res.data.data.id }
        const updateData = await UserRepository.updateProfilePic(payload, this.authUser.user, this.currentCircle.id)
        // this.init() // commented
        // UserRepository.getSelfProfile(this.authUser.user, this.currentCircle.id).then(res => {
        //   this.$store.commit("User/setAuthUserProfileBgImg", res.data.data.user_info)
        // })
        const newProfData = await UserRepository.getSelfProfile(this.authUser.user, this.currentCircle.id)
        this.$store.commit("User/setAuthUserProfileBgImg", newProfData.data.data.user_info)
        // const authUserData = updateData.data.data[0];
        // this.$store.commit("User/setAuthUserProfile", authUserData);
        this.isBackgroundImageLoading = false
        this.$notification.success({ message: "Success", description: "Image uploaded successfully" })
      } catch (err) {
        this.$notification.error({ message: "Failed", description: "Background Image not uploaded" })
        console.log(err)
        this.isBackgroundImageLoading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.dot-menu-cont1 {
  position: absolute;
  top: 0;
  right: 0;
  width: 60px;
}

.pos {
  position: absolute;
  left: 383px;
  top: 54px;
  z-index: 1;
}

.tabe {
  display: flex;
  gap: 5px;
  align-items: center;
  width: max-content;
}

.divider {
  width: 171px;
  height: 0px;
  border: 0.5px solid #e2e8f0;
  background-color: #e2e8f0;
  margin-left: 16px;
  margin-right: 16px;
}

.card-item {
  font-weight: 400 !important;
  font-size: 16px !important;
  margin-left: 0 !important;
  line-height: 32px;
  color: #1e2945;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}

.camera-icon-btn {
  .camera-bttn {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    text-align: center;
    border: 1px solid #f8fafd;

    i {
      vertical-align: bottom;
      color: #fff !important;
    }

    input {
      opacity: 0;
      width: 100%;
    }
  }
}

.child-tab-view {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 16px;
  position: absolute;
  max-width: 790px;
  left: 408px;
  top: 520px;
  width: 100%;

  @media screen and (max-width: 700px) {
    position: absolute;
    top: 1615px;
    // top: 1835px;
    // top: 1355px;
    width: 100%;
    left: 0px;
    padding: 16px;
    align-items: center;
  }
}

.bg-change-icon {
  cursor: pointer;
  top: 377px;
  // z-index: 100;

  @media screen and (max-width: 700px) {
    cursor: pointer;
    position: relative;
    top: 131px;
    left: 0px;
    z-index: 2;
  }
}

.tabs:hover {
  color: #2a71d4;
}

.active-tabs {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 24px;
  height: 48px;
  border-radius: 6px;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
}

.tabs {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 24px;

  height: 48px;

  border-radius: 6px;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
}

.profile-tab {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  position: absolute;
  width: 732px;
  height: 48px;
  left: 400px;
  top: 424px;

  @media screen and (max-width: 700px) {
    top: 1555px;
    // top: 1775px;
    // top: 1275px;
    left: 20px;
    overflow-x: scroll;
    width: 100%;
    padding-right: 38px;
    height: 410px;
  }
}

.profile-tab::-webkit-scrollbar {
  @media screen and (max-width: 700px) {
    display: none;
  }
}

.edit-status-info-container-last {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 8px;
  gap: 10px;

  width: 238px;
  height: 40px;
}

.profile-edit-header {
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #33415f;
}

.profile-edit-header-container {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 8px;
  gap: 10px;

  width: 334px;
  height: 40px;
}

.button-text {
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  color: #2a71d4;
  cursor: pointer;
}

.edit-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4px 16px;
  gap: 4px;
  // gap: 10px;
  width: 80px;
  height: 32px;
  color: #2a71d4;
  background: #e1eaf7;
  border-radius: 8px;
}

.edit-status-info-container {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 8px;
  gap: 10px;

  width: 214px;
  height: 40px;
}

.edit-status-info {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #33415f;
}

.green-tick {
  width: 20px;
  height: 20px;
}

.sub-profile-edit-even {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px;
  background: #f1f5f9;
  width: 334px;
  height: 56px;
}

.sub-profile-edit {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px;

  width: 334px;
  height: 56px;
}

.profile-completion-status {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 11px;
  width: 335px;
  height: 60px;
}

.custom-progress .ant-progress-text {
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 30px;
  text-align: right;
  color: #647490;
}

.custom-progress .ant-progress-bg {
  background-color: #2a71d4;
}

.profile-header {
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  color: #33415f;
}

.percentage-indicator {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  padding: 0px;
  width: 40px;
  height: 30px;
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  text-align: right;
  color: #647490;
}

.loader-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 16px;

  width: 335px;
  height: 30px;
}

.vertical-seperator {
  width: 1px;
  height: 36px;
  background: #cbd5e1;
}

.num {
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  text-align: center;
  color: #0f1734;
}

.num-text {
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  color: #94a3b8;
}

.circle-on {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px;

  width: 159.01px;
  height: 44px;
}

.circle-mem {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px;

  width: 159.01px;
  height: 44px;
}

.statistics {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 24px 8px;
  width: 335px;
  height: 92px;
  background: #ffffff;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
}

.seperator {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 8px 0px;

  width: 335px;
  height: 16px;
}

.location-text {
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  color: #0f1734;
}

.location-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  width: 335px;
  height: 24px;
}

.username {
  font-style: normal;
  font-weight: 700;
  font-size: 36px;
  line-height: 46px;
  color: #0f1734;
}

.username-container {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  width: 335px;
  height: 46px;

  @media screen and (max-width: 700px) {
    width: 96%;
  }
}

.options {
  width: 6px;
  height: 24px;
  cursor: pointer;
}

.avatar {
  width: 160px;
  height: 160px;
  cursor: pointer;
}

.avatar-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px;

  width: 309px;
  height: 160px;
}

.profile-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-start;
  padding: 0px;

  width: 315px;
  height: 160px;
}

.profile-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 16px;
  width: 335px;
  height: 1120px;

  @media screen and (max-width: 700px) {
    position: relative;
    top: 64px;
    align-items: center;
    width: 100%;
  }
}

.profile-card-container {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 24px;
  position: absolute;
  width: 383px;
  height: 1168px;
  top: 272px;
  background: #ffffff;
  box-shadow: 0px -8px 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;

  @media screen and (max-width: 700px) {
    padding: 0px;
    box-shadow: none;
    position: relative;
    align-items: baseline;
    height: 0px;
    left: 0px;
    top: 0px;
    width: 100%;
    background: none;
  }
}

.banner-image-container {
  width: 100%;
}

.banner-image {
  position: absolute;
  width: 100%;
  height: 400px;
  object-fit: cover;
  @media screen and (max-width: 700px) {
    width: 100%;
    height: 187px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Users/Patient/PatientProfile.vue